// extracted by mini-css-extract-plugin
export default {"AdminWrapper":"FeedItemAdminWrapper__AdminWrapper__oyzzz","AdminFeedItemDetails":"FeedItemAdminWrapper__AdminFeedItemDetails__Pc0Ob"};